module.exports = __webpack_public_path__ + "static/media/image72.0d94fcad.png";